import styled from '@emotion/styled';
import { spacing } from '../../../../../themes';

export const FileUploadList = styled.ul`
  display: flex;
  list-style-type: none;
  margin-top: ${spacing.xsmall};
  flex-flow: column;
  padding: 0;
  width: 100%;
`;
